"use client";

import * as React from "react";
import { cn } from "../../lib/utils";
import { PHONE_DEALS_STYLES } from "./constants";
import { PhoneDealsProps } from "./types";

export const PhoneDeals = React.forwardRef<HTMLDivElement, PhoneDealsProps>(
  ({ 
    className,
    title,
    description,
    phoneNumber,
    buttonText,
    onCallClick,
    agentImage,
    isVisible = true,
    ...props 
  }, ref) => {
    if (!isVisible) return null;

    return (
      <div
        ref={ref}
        className={cn(PHONE_DEALS_STYLES.container, className)}
        {...props}
      >
        <div className={PHONE_DEALS_STYLES.content}>
          {agentImage && (
            <div className={PHONE_DEALS_STYLES.imageWrapper}>
              <img
                src={agentImage}
                alt="Agent"
                className={PHONE_DEALS_STYLES.image}
              />
            </div>
          )}
          <div className={PHONE_DEALS_STYLES.textContent}>
            <h3 className={PHONE_DEALS_STYLES.title}>{title}</h3>
            <p className={PHONE_DEALS_STYLES.description}>{description}</p>
            <button
              onClick={onCallClick}
              className={PHONE_DEALS_STYLES.button}
              type="button"
            >
              <span className={PHONE_DEALS_STYLES.buttonText}>
                {buttonText} <span className={PHONE_DEALS_STYLES.phoneNumber}>{phoneNumber}</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
);

PhoneDeals.displayName = "PhoneDeals";
